module.exports = __webpack_public_path__ + "img/img_banner_size03.721e8fad.svg";